import {
  GET_DECEASED_USERS, SET_HSMV_REQUEST, RESET_DECEASED_USERS, SET_FILTERS, GET_DUPLICATE_CARDHOLDERS,
  RESET_DUPLICATE_USERS,
  SET_DUPLICATE_FILTERS
} from '../types/tools';
import { RESET_STATE } from '../types/global';

export interface ToolsState {
  deceasedUsersManagement: any,
  duplicateUsersManagement: any
}

const INITIAL_STATE: ToolsState = {
  deceasedUsersManagement: null,
  duplicateUsersManagement: null
};

const toolsReducer = function (state: ToolsState = INITIAL_STATE, action): ToolsState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;
    case GET_DECEASED_USERS:
      return {
        ...state,
        deceasedUsersManagement: {
          ...state.deceasedUsersManagement,
          deceasedCardholderResults: action.payload.deceasedCardholderResults,
          deceasedCardholderResultsCount: action.payload.deceasedCardholderResultsCount
        }
      };
    case SET_HSMV_REQUEST:
      return {
        ...state,
        deceasedUsersManagement: {
          ...state.deceasedUsersManagement,
          deceasedSource: action.payload
        }
      };
    case SET_FILTERS:
      return {
        ...state,
        deceasedUsersManagement: {
          ...state.deceasedUsersManagement,
          filters: action.payload
        }
      };
    case RESET_DECEASED_USERS:
      return { ...state, deceasedUsersManagement: null };
    case GET_DUPLICATE_CARDHOLDERS:
      return {
        ...state,
        duplicateUsersManagement: {
          ...state.duplicateUsersManagement,
          duplicateCardholderResults: action.payload.cardholders,
          duplicateCardholderResultsCount: action.payload.totalCount
        }
      };
    case SET_DUPLICATE_FILTERS:
      return {
        ...state,
        duplicateUsersManagement: {
          ...state.duplicateUsersManagement,
          filters: action.payload
        }
      };
    case RESET_DUPLICATE_USERS:
      return { ...state, duplicateUsersManagement: null };
    default:
      return state;
  }
};

export default toolsReducer;
